import { z } from 'zod';
import { currencyCodeSchema, reminderStepDaysSchema, uuidSchema } from './common.js';
export const meUserSchema = z.object({
    id: uuidSchema,
    telegramId: z.number().int().positive(),
    firstName: z.string().min(1),
    username: z.string().nullable(),
    languageCode: z.string().nullable(),
});
export const meSettingsSchema = z.object({
    baseCurrency: currencyCodeSchema,
    timezone: z.string().min(1),
    reminderHour: z.number().int().min(0).max(23),
    leadDays: reminderStepDaysSchema,
    overdueDays: reminderStepDaysSchema,
    autoGraceDays: z.number().int().min(0),
    locale: z.string().min(1),
});
export const meResponseSchema = z.object({
    user: meUserSchema,
    settings: meSettingsSchema,
});
//# sourceMappingURL=me.js.map